var A={ENTER:"Enter",ARROW_UP:"ArrowUp",ARROW_DOWN:"ArrowDown"},r={STANDARD:"standard"},E={GAP:8,MAX_HEIGHT:320,DEFAULT_ITEM_HEIGHT:44,VERTICAL_PADDING:16};export{r as DROPDOWN_VARIANT,A as EVENT_KEYS,E as MENU_PORTAL};
//# sourceMappingURL=dropdown.constants.js.map
